import { IconV2 } from 'components/common/IconV2/IconV2';
import type { MediumIconV2Props } from 'components/common/IconV2/IconV2.types';

const PinterestIcon = (props: MediumIconV2Props) => (
  <IconV2 {...props} viewBox="0 0 32 32">
    <path
      fill="currentcolor"
      fillRule="evenodd"
      d="M2 16c0 5.735 3.445 10.66 8.375 12.822-.039-.975 0-2.153.241-3.215l1.804-7.628s-.443-.898-.443-2.21c0-2.077 1.206-3.621 2.701-3.621 1.274 0 1.891.955 1.891 2.104 0 1.285-.82 3.196-1.235 4.973-.347 1.487.743 2.694 2.21 2.694 2.653 0 4.438-3.409 4.438-7.444 0-3.07-2.065-5.369-5.818-5.369-4.245 0-6.889 3.167-6.889 6.7 0 1.217.357 2.077.926 2.743.26.309.3.425.203.782-.068.26-.222.879-.29 1.12-.096.357-.376.483-.704.348-1.959-.802-2.866-2.945-2.866-5.35 0-3.977 3.358-8.747 9.996-8.747 5.346 0 8.858 3.872 8.858 8.024 0 5.493-3.05 9.597-7.546 9.597-1.514 0-2.933-.82-3.415-1.748 0 0-.81 3.225-.984 3.853-.3 1.081-.878 2.162-1.409 3.002 1.254.377 2.586.57 3.966.57C23.738 30 30 23.734 30 16S23.738 2 16.01 2 2 8.266 2 16"
      clipRule="evenodd"
    />
  </IconV2>
);

export default PinterestIcon;
